import {
  GET_USER,
  GET_USERSLIST,
  CLEAR_USER,
  CLEAR_ADMIN,
  LOGOUT,
  GET_BUILDING,
  CLEAR_BUILDING,
  GET_BUILDINGSLIST,
  CLEAR_FLOOR,
  GET_FLOOR,
  GET_FLOORSLIST,
  GET_CLIENT,
  GET_CLIENTSLIST,
  CLEAR_CLIENT,
  GET_CONFIGS,
  GET_PROJECTLIST,
  GET_PROJECT,
  SET_PROJECT,
  CLEAR_PROJECT,
  GET_DEPLOYMENTLIST,
  GET_DEPLOYMENT,
  SET_CLIENT,
  SET_BUILDING,
  SET_FLOOR,
  GET_ROOMSLIST,
  GET_ROOM,
  SET_ROOM,
  CLEAR_ROOM,
  GET_DEVICELIST,
  CLEAR_CONFIGS,
  MODIFY_CONFIGS,
} from "../actions/types";
import api from "../utils/api";
import { setAlert } from "./alertAction";

export const setUser = (user) => (dispatch) => {
  dispatch({ type: GET_USER, payload: user });
};

export const getUser = (id) => async (dispatch) => {
  try {
    const res = await api.get("/user/" + id);
    dispatch({ type: GET_USER, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const loadUsersList = () => async (dispatch) => {
  try {
    const res = await api.get("/user");
    console.log(res);
    dispatch({ type: GET_USERSLIST, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const updateUser = (userId, formData) => async (dispatch) => {
  try {
    await api.put(`/user/${userId}`, formData);
    dispatch(loadUsersList());
    dispatch(setAlert("User updated Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const addUser = (formData) => async (dispatch) => {
  try {
    await api.post("/user", formData);
    dispatch(loadUsersList());
    dispatch(setAlert("User Added Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};
// export const importUsers = (formData) => async (dispatch) => {
//   try {
//     await api.post('/users/import', formData);
//     dispatch(loadUsersList());
//   } catch (err) {
//     const errors = err.response.data.errors;

//     if (errors) {
//       if (errors[0].msg === 'Session Expired') {
//         dispatch({ type: LOGOUT });
//         dispatch(clearAll());
//       } else
//         errors.forEach((error) => dispatch(setAlert(error.message, 'danger')));
//     }
//     console.log(err);
//   }
// };

export const deleteUser = (userId) => async (dispatch) => {
  try {
    await api.delete(`/user/${userId}`);
    dispatch(loadUsersList());
    dispatch(setAlert("User Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const clearUser = () => (dispatch) => {
  dispatch({ type: CLEAR_USER });
};

export const setClient = (client) => (dispatch) => {
  dispatch({ type: GET_CLIENT, payload: client });
  dispatch({ type: SET_CLIENT, payload: client });
};

export const getClient = (id) => async (dispatch) => {
  try {
    const res = await api.get("/client/" + id);
    dispatch({ type: GET_CLIENT, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const loadClientsList = () => async (dispatch) => {
  try {
    const res = await api.get("/client");
    console.log(res);
    dispatch({ type: GET_CLIENTSLIST, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const updateClient = (clientId, formData) => async (dispatch) => {
  try {
    await api.put(`/client/${clientId}`, formData);
    dispatch(loadClientsList());
    dispatch(setAlert("Company updated Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const addClient = (formData) => async (dispatch) => {
  try {
    await api.post("/client", formData);
    dispatch(loadClientsList());
    dispatch(setAlert("Company Added Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const deleteClient = (clientId) => async (dispatch) => {
  try {
    await api.delete(`/client/${clientId}`);
    dispatch(loadClientsList());
    dispatch(setAlert("Client Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const clearClient = () => (dispatch) => {
  dispatch({ type: CLEAR_CLIENT });
};

export const setBuilding = (building) => (dispatch) => {
  // dispatch({ type: GET_BUILDING, payload: building });
  dispatch({ type: SET_BUILDING, payload: building });
};

export const getBuilding = (id) => async (dispatch) => {
  try {
    const res = await api.get("/building/" + id);
    dispatch({ type: GET_BUILDING, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const loadBuildingsList = () => async (dispatch) => {
  try {
    const res = await api.get("/building");
    console.log(res);
    dispatch({ type: GET_BUILDINGSLIST, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const updateBuilding = (buildingId, formData) => async (dispatch) => {
  try {
    await api.put(`/building/${buildingId}`, formData);
    dispatch(loadBuildingsList());
    dispatch(setAlert("Building updated Successfully", "success"));
    dispatch(clearBuilding());
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const addBuilding = (formData) => async (dispatch) => {
  try {
    await api.post("/building", formData);
    dispatch(loadBuildingsList());
    dispatch(setAlert("Building Added Successfully", "success"));
    dispatch(clearBuilding());
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};
// export const importUsers = (formData) => async (dispatch) => {
//   try {
//     await api.post('/users/import', formData);
//     dispatch(loadUsersList());
//   } catch (err) {
//     const errors = err.response.data.errors;

//     if (errors) {
//       if (errors[0].msg === 'Session Expired') {
//         dispatch({ type: LOGOUT });
//         dispatch(clearAll());
//       } else
//         errors.forEach((error) => dispatch(setAlert(error.message, 'danger')));
//     }
//     console.log(err);
//   }
// };

export const deleteBuilding = (buildingId) => async (dispatch) => {
  try {
    await api.delete(`/building/${buildingId}`);
    dispatch(loadBuildingsList());
    dispatch(setAlert("Building Deleted Successfully", "info"));
    dispatch(clearBuilding());
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const clearBuilding = () => (dispatch) => {
  dispatch({ type: CLEAR_BUILDING });
};
export const setFloor = (floor) => (dispatch) => {
  dispatch({ type: GET_FLOOR, payload: floor });
  dispatch({ type: SET_FLOOR, payload: floor });
};

export const getFloor = (id) => async (dispatch) => {
  try {
    const res = await api.get("/floor/" + id);
    dispatch({ type: GET_FLOOR, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const loadFloorsList = () => async (dispatch) => {
  try {
    const res = await api.get("/floor");
    console.log(res);
    dispatch({ type: GET_FLOORSLIST, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const updateFloor = (floorId, formData) => async (dispatch) => {
  try {
    console.log("test action form data", formData);
    await api.put(`/floor/${floorId}`, formData);
    dispatch(loadFloorsList());
    dispatch(setAlert("Floor updated Successfully", "success"));
    dispatch(clearFloor());
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const addFloor = (formData) => async (dispatch) => {
  try {
    await api.post("/floor", formData);
    dispatch(loadFloorsList());
    dispatch(setAlert("Floor Added Successfully", "success"));
    dispatch(clearFloor());
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const deleteFloor = (floorId) => async (dispatch) => {
  try {
    await api.delete(`/floor/${floorId}`);
    dispatch(loadFloorsList());
    dispatch(setAlert("Floor Deleted Successfully", "info"));
    dispatch(clearFloor());
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const clearFloor = () => (dispatch) => {
  dispatch({ type: CLEAR_FLOOR });
};

export const clearAll = () => (dispatch) => {
  dispatch({ type: CLEAR_ADMIN });
};

export const loadRoomsList = () => async (dispatch) => {
  try {
    const res = await api.get("/room");
    dispatch({ type: GET_ROOMSLIST, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const addRoom = (formData) => async (dispatch) => {
  try {
    await api.post("/room", formData);
    dispatch(getFloor(formData.floors_id));
    dispatch(setAlert("Room Added Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const updateRoom = (roomId, formData) => async (dispatch) => {
  try {
    await api.put(`/room/${roomId}`, formData);
    dispatch(getFloor(formData.floors_id));
    dispatch(setAlert("Room Updated Successfully", "info"));
    dispatch(clearRoom());
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const setRoom = (room) => (dispatch) => {
  dispatch({ type: GET_ROOM, payload: room });
  dispatch({ type: SET_ROOM, payload: room });
};

export const clearRoom = () => (dispatch) => {
  dispatch({ type: CLEAR_ROOM });
};

export const deleteRoom = (roomId, floorId) => async (dispatch) => {
  try {
    console.log(roomId);
    await api.delete(`/room/${roomId}`);
    dispatch(getFloor(floorId));
    dispatch(setAlert("Room Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const getConfigs = (queryObj) => async (dispatch) => {
  try {
    const { client, building, floor, room } = queryObj;

    const res = await api.post("/configs", {
      client_id: client.client_id ? client.client_id : undefined,
      buildingID: building.building_id ? building.building_id : undefined,
      floorID: floor.floor_id ? floor.floor_id : undefined,
      roomID: room.room_id ? room.room_id : undefined,
    });

    dispatch({ type: GET_CONFIGS, payload: res.data });
  } catch (error) {
    const errors = error.response.data.errors;
    // Logic 1
    // if (errors)
    //   if (errors[0].msg === "Session Expired") {
    //     dispatch({ type: LOGOUT });
    //     dispatch(clearAll());
    //   }
    //   else{
    //    console.log(errors);
    //   }

    //Logic 2
    // extract the default config for Adding new config
    const default_configs = error.response.data.default_configs;

    if (!default_configs){
      dispatch({ type: LOGOUT });
      dispatch(clearAll());
    }
    else{
      dispatch({ type: GET_CONFIGS, payload: {default_configs, config:default_configs, setNew:true}});
    }
  }
};

export const modifyConfigs = (isModified)=>(dispatch)=>{
  dispatch({type: MODIFY_CONFIGS, payload: isModified});
}

export const updateConfigs = (formData) => async (dispatch) => {
  try {
    await api.post("/configs/update", formData);
    dispatch(setAlert("Configs Updated Successfully", "success"));
    // dispatch(getConfigs(formData.client_id ? formData.client_id : undefined));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

// Project
export const loadProjectList = (params) => async (dispatch) => {
  try {
    const { data } = await api.get(`/project`);
    dispatch({ type: GET_PROJECTLIST, payload: data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const getProject = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/project/${id}`);
    dispatch({ type: GET_PROJECT, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const setProject = (project) => (dispatch) => {
  // dispatch({ type: GET_PROJECT, payload: project });
  dispatch({ type: SET_PROJECT, payload: project });
};

export const addProject = (formData) => async (dispatch) => {
  try {
    await api.post("/project", formData);
    // dispatch(loadProjectList());
    dispatch(setAlert("Project Added Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const updateProject = (projectId, formData) => async (dispatch) => {
  try {
    await api.put(`/project/${projectId}`, formData);
    // dispatch(loadProjectList());
    dispatch(setAlert("Project updated Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
    }
  }
};

export const deleteProject = (projectId) => async (dispatch) => {
  try {
    await api.delete(`/project/${projectId}`);
    dispatch(loadProjectList());
    dispatch(setAlert("Project is Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

// Deployment
export const loadDeploymentList = (params) => async (dispatch) => {
  try {
    const { data } = await api.get(`/deployment`);
    dispatch({ type: GET_DEPLOYMENTLIST, payload: data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const getDeployment = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/deployment/${id}`);
    dispatch({ type: GET_DEPLOYMENT, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const addDeployment = (formData) => async (dispatch) => {
  try {
    await api.post("/deployment", formData);
    // dispatch(loadDeploymentList());
    dispatch(setAlert("Deployment Added Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const updateDeployment =
  (deploymentID, formData) => async (dispatch) => {
    try {
      await api.put(`/deployment/${deploymentID}`, formData);
      // dispatch(loadDeploymentList());
      dispatch(setAlert("Deployment updated Successfully", "success"));
    } catch (err) {
      console.log(err);
      const errors = err.response.data.errors;

      if (errors) {
        if (errors[0].msg === "Session Expired") {
          dispatch({ type: LOGOUT });
          dispatch(clearAll());
        }
      }
    }
  };

export const deleteDeployment = (deploymentId) => async (dispatch) => {
  try {
    await api.delete(`/deployment/${deploymentId}`);
    dispatch(loadDeploymentList());
    dispatch(setAlert("Deployment is Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

// Device
export const loadDeviceList = (params) => async (dispatch) => {
  try {
    const { data } = await api.get(`/device`);
    dispatch({ type: GET_DEVICELIST, payload: data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const getDevice = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/device/${id}`);
    dispatch({ type: GET_DEPLOYMENT, payload: res.data.data });
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};

export const addDevice = (formData) => async (dispatch) => {
  try {
    await api.post("/device", formData);
    dispatch(loadDeviceList());
    dispatch(setAlert("Device Added Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      } else
        errors.forEach((error) => dispatch(setAlert(error.message, "danger")));
    }
  }
};

export const updateDevice = (deviceID, formData) => async (dispatch) => {
  try {
    await api.put(`/device/${deviceID}`, formData);
    dispatch(loadDeviceList());
    dispatch(setAlert("Device updated Successfully", "success"));
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
    }
  }
};

export const deleteDevice = (deviceId) => async (dispatch) => {
  try {
    await api.delete(`/device/${deviceId}`);
    dispatch(loadDeviceList());
    dispatch(setAlert("Device is Deleted Successfully", "info"));
  } catch (error) {
    console.log(error);
    const errors = error.response.data.errors;
    if (errors)
      if (errors[0].msg === "Session Expired") {
        dispatch({ type: LOGOUT });
        dispatch(clearAll());
      }
  }
};
